<div class="marv_tabs">
    <div class="marv_tabs_bar">
        @for(tab of this.tabs; track $index){
            @if(!tab.hide){
                <div class="marv_tab_button" 
                    [class.selected]="this.selectedTab?.id === tab.id" 
                    [class.with_marv_circle]="tab.countItems !== undefined" 
                    (click)="this.selectTab(tab)"
                    >
                    @if(tab.iconPrefix){
                        <ion-icon class="marv_tab_button_icon_prefix" [name]="tab.iconPrefix"></ion-icon>
                    }
                    @if(tab.label){
                        {{tab.label}}
                    }
                    @if(tab.iconSuffix){
                        <ion-icon class="marv_tab_button_icon_suffix" [name]="tab.iconSuffix"></ion-icon>
                    }
                    @if(tab.countItems !== undefined){
                        <marv-circle>{{tab.countItems}}</marv-circle>
                    }
                </div>
            }
        }
    </div>

    @for(tab of this.tabsContentList; track $index){              
        <div class="marv_tab" [class.selected]="this.selectedTab?.id === tab.id">
            <ng-container *ngTemplateOutlet="tab.content"></ng-container>            
        </div>        
    }

</div>
